import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

const TrademarkImagePreview = ({
  trademarkImage,
  applicationNum,
  alt,
  fallback,
  size = 122,
  borderRadius = "14px",
}) => {
  const imageUrl =
    trademarkImage ||
    (applicationNum ? `https://tsdr.uspto.gov/img/${applicationNum}/large` : "");
  const [imageStatus, setImageStatus] = useState(imageUrl ? "loading" : "error");

  useEffect(() => {
    if (!imageUrl) {
      setImageStatus("error");
      return undefined;
    }

    let isMounted = true;
    const image = new window.Image();

    setImageStatus("loading");

    image.onload = () => {
      if (isMounted) {
        setImageStatus("loaded");
      }
    };

    image.onerror = () => {
      if (isMounted) {
        setImageStatus("error");
      }
    };

    image.src = imageUrl;

    return () => {
      isMounted = false;
    };
  }, [imageUrl]);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius,
        border: "1px solid #c9d8ea",
        backgroundColor: "#f5f9ff",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageUrl && imageStatus === "loaded" ? (
        <Box
          component="img"
          src={imageUrl}
          alt={alt}
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            backgroundColor: "#ffffff",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.75,
            px: 1,
            textAlign: "center",
            background:
              "linear-gradient(135deg, rgba(233, 242, 255, 0.95) 0%, rgba(245, 249, 255, 1) 100%)",
          }}
        >
          <ImageOutlinedIcon
            sx={{
              fontSize: size < 80 ? 28 : 36,
              color: "#6b85a8",
            }}
          />
          <Typography
            sx={{
              color: "#5c7393",
              fontSize: size < 80 ? "0.68rem" : "0.78rem",
              fontWeight: 700,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              lineHeight: 1.2,
            }}
          >
            {imageStatus === "loading" ? "Loading..." : "No Image"}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TrademarkImagePreview;
